<template>
	<div class="point-Order-Pay-main">
		<div class="jifen-title" style="margin-top: 20px;">换购商品</div>
		<div class="point-Order-Pay" style="margin-top: 0px;">
			<div style="display: flex;">
				<img class="goods-image" :src="goodsInfoObj.PictureUrl" />
				<div class="goods-image" style="display: flex;flex-direction: column;">
					<div class="goos-name">{{goodsInfoObj.Name}}</div>
					<div class="goos-name">数量:{{goodsNum}}</div>
					<div class="goos-name" style="color: firebrick;width: 200px;display: flex;">售价:
						<p>{{goodsInfoObj.Integral}}积分</p>
						<p v-if="this.goodsInfoObj.GrouponPrice>0">+{{goodsInfoObj.GrouponPrice}}元</p>
					</div>
				</div>
			</div>
		</div>
		<div class="jifen-title">积分选择（可多选）</div>
		<div class="member-list-content" style="margin-top: 0px;">
			<div class="member-list" v-for="(item,index) in memberCardList" :key="index">
				<div class="member-item" @click="chooseCard(index,item)">
				<img src="../../assets/images/huiyuannianxian@2x.png" class="goods-image"></img>
					<div class="goods-image" style="display: flex;flex-direction: column;flex: 1;">
						<div class="card-name">卡种:{{item.CardTypeName}}</div>
						<div class="card-name">卡后:{{item.CardCode}}</div>
						<div class="card-name">积分:<div
								style="color: firebrick;font-weight: 500;">{{item.Integral}}</div></div>
						<div class="card-name" style="display: flex;">积分有效截止时间:{{item.EndTime}}
							<div v-if="item.Seleted==true&&item.Integral>0" class="choose-image"
								style="margin-top: 0px;" :class="'iconfont icon-yuanxingxuanzhongfill check_icon'">
							</div>
							<div v-else-if="item.Integral>0" class="choose-image" style="margin-top: 0px;"
								:class="'iconfont icon-yuanxingweixuanzhong un_check_icon'">
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="weichat-view" v-if="this.goodsInfoObj.GrouponPrice>0">
				 <g-img2 src="wx_icon.png" class="wechat-image"></g-img2>
				<div class="wechat-image" style="height:64px;line-height:30px;width: auto;padding-left: 20px;">微信支付
				</div>
				<div class="choose-image" style="width: 30px;height: 30px;" :class="'iconfont icon-yuanxingxuanzhongfill check_icon'">
				</div>
			</div>
			<div class="bottom-view">
				<div style="flex: 1;">
					<div class="card-name">积分:{{goodsNum*goodsInfoObj.Integral}}</div>
					<div class="card-name" v-if="this.goodsInfoObj.GrouponPrice>0">金额:¥
						{{goodsNum*goodsInfoObj.GrouponPrice}}
					</div>
				</div>
				<div class="submit-btn" @click="submitOrder()">立即支付</div>
			</div>

		</div>

	</div>

</template>

<script>
import { handleSessionStorage } from "@/utils";
import { getOrderInfo } from "../../api/goods";
import { getMemberCardList } from "../../api/member";
import { getPointGoodsDatail, submitPointGoodsOrder } from "../../api/point";
import { getOrderDetail } from "@/api/order";
import { sqbH5Pay, sqbWxPay } from '@/api/pay';
export default {
  name: "pointOrderPay",
  data() {
    return {
      orderInfo: {},
      orderId: "",
      vpnCode: "",
      vpnId: "",
      goodsNum: this.$route.params.goodsNum,
      goodsId: this.$route.params.id,
      memberCardList: [],
      goodsInfoObj: {},
    };
  },
  created() {
    this.goodsId = this.$route.params.id;
    this.goodsNum = this.$route.params.goodsNum;
    this.handleGetPointGoodsInfo(this.goodsId);
    this.handleGetMemberList();
  },
  methods: {
    chooseCard(index, item) {
      if (item.Integral == 0) {
        this.$toast(item.CardTypeName + "积分为0 ，不可选择");
        return;
      }
      const mTotalIntegral = this.goodsNum * this.goodsInfoObj.Integral;
      const cardList = this.memberCardList.filter(
        (mode) => mode.Seleted == true
      );
      var currentIntegral = 0;
      cardList.forEach((mode) => {
        currentIntegral = currentIntegral + mode.PayIntegal;
      });
      item.Seleted = !item.Seleted;
      if (currentIntegral >= mTotalIntegral && item.Seleted) {
        this.$toast("已经能够足额支付,请不要再选择");
        item.Seleted = false;
      } else {
        const PayIntegral = mTotalIntegral - currentIntegral;
        if (item.Seleted) {
          if (item.Integral > PayIntegral) {
            item.PayIntegal = PayIntegral;
          } else {
            item.PayIntegal = item.Integral;
          }
        } else {
          item.PayIntegal = 0;
        }
      }
      this.memberCardList[index] = item;
    },
    handleGetMemberList() {
      getMemberCardList({
        IsBindWx: true,
        VpnId: this.$store.state.vpnId,
      }).then((res) => {
        res.forEach((item, index) => {
          item.EndTime = item.EndTime ? item.EndTime.split(" ")[0] : "";
          item.StartTime = item.StartTime ? item.StartTime.split(" ")[0] : "";
          item.allMoney = item.DonationMoney + item.LeaveMoney;
          item.PayIntegal = 0;
          item.Seleted = false;
          res[index] = item;
        });
        this.memberCardList = res;
        if (this.memberCardList.length > 0) {
          const index = this.memberCardList.findIndex(
            (mode) => mode.Integral > 0
          );
          if (index != -1) {
            this.chooseCard(index, this.memberCardList[index]);
          }
        }
      });
    },
    submitOrder() {
      const cardList = this.memberCardList.filter(
        (mode) => mode.Seleted == true
      );
      if (cardList.length == 0) {
        this.$toast("请选择会员卡积分");
        return;
      }
      const lstMemberIntegalItems = [];
      cardList.forEach((mode) => {
        lstMemberIntegalItems.push({
          MemberGuid: mode.MemberGuid,
          CardCode: mode.CardCode,
          CardTypeName: mode.CardTypeName,
          Integal: mode.PayIntegal,
        });
      });
      const params = {
        lstMemberIntegalItem: lstMemberIntegalItems,
        IntegralMallGoodsId: this.goodsId,
        Number: this.goodsNum,
        EventClientId: 1, //活动终端类型，0:H5 1:小程序
      };
      submitPointGoodsOrder(params)
        .then((res) => {
          this.orderId = res;
          this.handleGetOrderInfo();
        })
        .catch(() => {});
    },
    /**查询订单详情**/
    handleGetOrderInfo() {
      getOrderDetail({
        "query.id": this.orderId,
      }).then((res) => {
        if (res.Items.length == 0) {
          this.$toast("订单异常,订单数据为空");
        } else {
          const infoData = res.Items[0];
          if (infoData.Receipts > 0) {
            this.orderInfo = {
              ...infoData,
            };
          this.onPay(this.orderInfo.SequenceId, this.orderId)
          } else {
            this.$toast("兑换成功");
            setTimeout(() => {
              this.$router.replace({ name: "PointHistoryPage" });
            }, 1500);
          }
        }
      });
    },
    // 支付
    async handlePayGoods() {
      await this.$pub.wechatPay(
        this.orderInfo.SequenceId,
        this.orderInfo.Receipts * 100,
        {
          backUrl: "PointHistoryPage",
          payType: "",
          vpnCode: "",
          orderId: this.orderId,
          GroupCouponPayments: [],
          payAfterUrl: "CollageSubmission",
          sqbAfterUrl: "CollageSubmission",		  
        }
      );
    },
	onPay(sequenceId, orderId) {
        
	  let returnUrl = location.href.split('#')[0] + '#/goods/order'
      let payRequest = ''
      let requestParams = {
        OutTradeNo: sequenceId,
        Subject: `${this.goodsInfoObj.Name}${orderId}`,
        Fee: Number(this.orderInfo.Receipts * 100),
        Payway: 3,
        ReturnUri: returnUrl,
      }
      if (this.isWeChatClient) {
        payRequest = sqbWxPay // 微信内置浏览器环境下，调用收钱吧公众号支付
      } else {
        payRequest = sqbH5Pay // 其他环境下调用收钱吧H5支付
        requestParams.SubPayway = 6
        requestParams.UserIp = localStorage.getItem('Ip')
      }
      payRequest(requestParams)
        .then(res => {
          if (res) {
            // 支付跳转链接
            if (this.isWeChatClient) {
              location.href = res
            } else if (res.wap_pay_request.h5_pay_redirect_url) {
              location.href = `${res.wap_pay_request.h5_pay_redirect_url}&redirect_url=${encodeURIComponent(returnUrl)}`
            }
          }
        })
        .catch(err => {
          // console.log(err)
        })
	},
    handleGetPointGoodsInfo(goodsId) {
      // 获取产品详情
      getPointGoodsDatail(goodsId).then((res) => {
        const data = res;
        data.GrouponPrice = 0;
        data.Name = data.GoodsName;
        data.Integral = data.Integral;
        data.GrouponPrice = data.Money;
        data.Introduction = data.Description;
        data.ImageText = data.ImageText;
        data.Instruction = data.Instruction;
        data.DrawMaxNumByOne = data.PersonLimit;
        data.DrawMaxNumByOneByDay = data.PersonDayLimit;
        data.ExpireDateDescription = data.ExpireDateDescription;
        data.MinBuyCount = data.MinBuyCount || 1; //起购数量
        data.StepBuyCount = data.StepBuyCount || 1; //购买步长
        data.allSaleNumber = data.SaleCount || 0;
        this.goodsInfoObj = data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.point-Order-Pay-main {
  // height: 100%;
  width: 100%;
  background-color: #f5f5f5;
  padding-bottom: calc(130px + env(safe-area-inset-bottom));

  .point-Order-Pay {
    background-color: white;
    height: 200px;
    padding: 20px;
  }

  .goods-image {
    width: 160px;
    height: 160px;
    padding: 20px;
    border-radius: 20px;
  }

  .goos-name {
    width: 100vh;
    height: 53px;
    line-height: 53px;
  }

  .jifen-title {
    font-size: 1.2rem;
    padding: 20px;
    width: 100%;
    background: aliceblue;
  }

  .member-list-content {
    height: 200px;
  }

  .member-list {
    width: 100vh;
    flex: 1;
  }

  .member-item {
    display: flex;
    width: 100%;
    background-color: white;
    border-radius: 10px;
    padding-left: 10px;
    padding-right: 10px;
    border-bottom: 1px solid lavender;
  }

  .weichat-view {
    width: 100%;
    height: 100px;
    display: flex;
    padding-left: 30px;
    padding-right: 30px;
    background-color: white;
  }

  .wechat-image {
    margin-top: 20px;
    height: 64px;
    width: 64px;
  }

  .wechat-choose-image {
    height: 40px;
    width: 40px;
    margin-left: 100px;
    margin-top: 30px;
  }

  .card-name {
    width: auto;
  }

  .choose-image {
    width: 20px;
    height: 20px;
    margin-left: 60px;
    margin-top: 40px;
  }

  .bottom-view {
    @include fixed-bottom-box-con;
    display: flex;
    height: 100px;
    width: 100%;

    .submit-btn {
      width: auto;
      margin-top: 10px;
      padding-left: 30px;
      padding-right: 30px;
      height: 80px;
      line-height: 80px;
      margin-right: 80px;
      border-radius: 40px;
      background-color: black;
      color: white;
      font-size: 1rem;
    }
  }
}
</style>